module.exports = __webpack_public_path__ + "static/media/logo.da9c769b.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 45
// module chunks = 0